import React, { Component } from 'react';
import xtend from 'xtend';

export default function KeyWatcher (WrappedComponent) {
    return class extends Component {
        constructor (props) {
            super(props);
        }

        render () {
            return React.createElement(
                WrappedComponent,
                xtend({}, this.props),
                this.props.children || []
            );
        }
    };
}
